import axios from "./http";

let { get, post, patch, siidelete } = axios

// post example
export const post_example = data => post("/mcapi/cwcash/executecworder", data)

// get example
export const get_example = data => get("/mcapi/cwcash/getorderinfo", data)

// 登录发送验证码
export const sendsms = data => post('/cwapi/sendsms', data)

// 注册
export const register = data => post("/cwapi/register", data)

// 获取网站配置
export const getsiteconfig = data => get("/cwapi/config", data)

//获取自定义配置信息
export const getconfigs = data => get("/cwapi/config", data)

// 登陆
export const login = data => post("/cwapi/login", data)

// 修改密码
export const resetpassword = data => post('/cwapi/resetpassword', data)


// 获取用户信息
export const getcwinfo = data => get("/cwapi/userinfo", data)


//团队报表
export const teamreport = data => post("/cwapi/teaminfo/report", data)


export const teaminfoport = data => post("/cwapi/statistics/teaminfo", data)





// 新闻相关
// 获取文章(通过id)
export function getnewsIddetail(id) {
    return get("/cwapi/news/detail/" + id);
}

// 获取文章(通过code)
export function getnewsCodedetail(code) {
    return get("cwapi/news/code/" + code);
}

// 获取新闻列表
export const getnewslist = data => get("/cwapi/news/list", data)

// 获取通知
export const getnotice = data => get("/cwapi/news/notice", data)


// 获取费率
export const getcwexchangerate = data => get('/cwapi/config?k=itoken_buy_settings', data)


//邀请相关
export const referral = data => get("/cwapi/referral ", data)
export const newreferral = data => post("/cwapi/referral", data)
export const delreferral = data => post("/cwapi/referral/del", data)


// 修改下级成员分红比例
export const editchilderbonusratio = data => post("/cwapi/childerpayeereward/edit/ratio", data)


export const getmyteam = data => get("/cwapi/teaminfo", data)


// 给下级转账
export const transfertochild = data => post('/cwapi/transfertochilder', data)


// 获取 ct 账号列表
export const getcollectiontoollist = data => get('/cwapi/collectiontool', data)

// 获取单个 ct 详情
export const getcollectiontool = data => get('/cwapi/collectiontool', data)

// 开启售卖ct
export const startsell = data => post("/cwapi/collectiontool/startsell", data)

// 停止售卖ct
export const stopsell = data => post("/cwapi/collectiontool/stopsell", data)

// 资金记录
export const getassetsrecord = data => get("/cwapi/quotalog", data)


// 监控登录流程
export const monitorflowone = data => post("/cwapi/monitorflow/one", data)

export const monitorflowtwo = data => post("/cwapi/monitorflow/two", data)

export const monitorflowtwo_getpreloginresult = data => post("cwapi/monitorflow/two/getpreloginresult", data)

export const monitorflowthree = data => post("/cwapi/monitorflow/three", data)

export const monitorflowcheck = data => post("/cwapi/monitorflow/check", data)

export const editcollectiontool = data => post('/cwapi/collectiontool', data)

//USDT充值
export const getwalletaddress = data => get("/cwapi/getwalletaddress", data)

// 获取购买itoken历史
export const getbuyitokenhistory = data => get("/cwapi/buyitoken/history", data)

// 获取付款单
export const getpaymentslip = data => get("/cwapi/buyitoken/waitpayerpaymentslip", data)

//获取可用付款的 ct
export const getavailablect = data => get('/cwapi/availablect', data)

// 获取付款单详情
export const getpaymentslipdetail = data => get('/cwapi/buyitoken/paymentslipdetail', data)

//抢单
export const pickuppaymentslip = data => post("/cwapi/buyitoken/pickuppaymentslip", data)

// 处理订单
export const processpaymentslips = data => post("/cwapi/buyitoken/processpaymentslips", data)

//上传图片
export const uploadimage = data => post("/cwapi/uploadimage", data)

// 获取通知未读数
export const unreadcount = data => get('/cwapi/notify/api/unread_count/', data)

// 获取通知未读列表
export const unreadlist = data => get('/cwapi/notify/api/unread_list/', data)

// 获取通知列表
export const alllist = data => get('/cwapi/notify/api/all_list/', data)

//消息标记为已读
export const messageasread = data => get('/cwapi/notify/mark-as-read/' + data)

//全部标记为已读
export const allmessageasread = data => get('/cwapi/notify/mark-all-as-read/', data)

// 获取客服列表
export const getcwcustomerservicelist = data => get('/cwapi/customerservice', data)


// 获取售卖历史
export const getsellhistory = data => get('/cwapi/sell/history', data)

// 账单问题提交
export const submitbillquestion = data => post('/cwapi/sell/question', data)

// 编辑
export const addcollectiontool = data => post('/cwapi/collectiontool', data)

// 删除 ct
export const deletecollectiontool = data => siidelete('/cwapi/collectiontool', data)

export const authupi = data => post("/cwapi/authupi/", data)

// 排行榜
export const getcwinviterank = data => get('/cwapi/cw_inviterank/', data)

export const getcwprofitrank = data => get('/cwapi/cw_profitrank/', data)

export const teaminfothree = data => get('/cwapi/teaminfothree/', data)

// KYC身份验证
export const cwkyc = data => post('/cwapi/cwkyc/', data)

// 获取KYC身份验证信息
export const getcwkyc = data => get('/cwapi/cwkyc/', data)

// 编辑kyc
export const modifykyc = data => patch('/cwapi/cwkyc/', data)

// 新增银行卡
export const addbank = data => post('/cwapi/bank', data)

// 修改银行卡信息
export const editbank = data => post('/cwapi/bank/edit', data)

// 获取银行卡信息
export const getbanklist = data => get('/cwapi/bank', data)

// 暂停银行卡手款
export const pausebank = data => post('/cwapi/bank/pause', data)

// 获取银行卡激活的信息
export const getavailablebank = data => get('/cwapi/availablebank', data)



// WEBPACK FOOTER //
// ./src/request/api.js